import { getErrorMessage } from 'utils/stringUtils';

export const types = {
  CLOSE_MERGE_MODAL: 'modules/common/modals/mergeModal/CLOSE_MERGE_MODAL',
  OPEN_MERGE_MODAL: 'modules/common/modals/mergeModal/OPEN_MERGE_MODAL',
  MERGE_QUOTE_ITEMS_ERROR:
    'modules/common/modals/mergeModal/MERGE_QUOTE_ITEMS_ERROR',
  MERGE_QUOTE_ITEMS_REQUEST:
    'modules/common/modals/mergeModal/MERGE_QUOTE_ITEMS_REQUEST',
  MERGE_QUOTE_ITEMS_SUCCESS:
    'modules/common/modals/mergeModal/MERGE_QUOTE_ITEMS_SUCCESS',
};

export const mergeModal = {
  close: () => ({
    type: types.CLOSE_MERGE_MODAL,
  }),
  open: ({ mergeType, selectedQuoteItems }) => ({
    type: types.OPEN_MERGE_MODAL,
    payload: { mergeType, selectedQuoteItems },
  }),
};

export const mergeQuoteItems = {
  request: ({
    parentQuoteItemId,
    childrenQuoteItemIds,
    shouldRegenerateOps,
  }) => ({
    type: types.MERGE_QUOTE_ITEMS_REQUEST,
    payload: { parentQuoteItemId, childrenQuoteItemIds, shouldRegenerateOps },
  }),
  success: () => ({
    type: types.MERGE_QUOTE_ITEMS_SUCCESS,
  }),
  error: (error) => ({
    type: types.MERGE_QUOTE_ITEMS_ERROR,
    payload: getErrorMessage(error),
  }),
};
